import React from "react";
import { graphql } from "gatsby";
import LogoEpp from "../icons/logo-epp.svg";

const FooterEpp = ({ data }) => {
  const {
    footerMenuFiltered: { legalInfo },
  } = data;

  return (
    <div className="footer footer--epp">
      <div className="container-fluid wrapper">
        <div className="row">
          <div className="col-12 order-md-2">
            <div className="footer__border d-flex justify-content-between align-items-center py-3 py-md-4 mt-md-3">
              <div className="d-flex align-items-center pr-3">
                <div className="logo">
                  <LogoEpp />
                </div>
                {legalInfo && (
                  <span className="d-none d-md-block ml-3 align-self-center footer__copyright">
                    {legalInfo}
                  </span>
                )}
              </div>
            </div>
          </div>
          {legalInfo && (
            <div className="col-12 d-md-none">
              <div className="footer__item py-3">
                <span className="footer__copyright">{legalInfo}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FooterEpp;
export const query = graphql`
  query {
    footerMenuFiltered {
      legalInfo
    }
  }
`;
